<template>
  <div id="layout">
    <template v-if="isInit">
      <router-view />
    </template>
  </div>
</template>
<script>
import storage from "@/utils/storage";
import { mapActions, mapGetters } from "vuex";
import { weichatAutoLogin } from "@/api/user";
export default {
  data() {
    return {
      isInit: false,
    };
  },
  computed: {
    ...mapGetters(["vuexInitData", "indexData"]),
  },
  async created() {
    this.showLoading();
    const { token, game_id, is_new, from, gid } = this.$route.query;

    if (from) {
      sessionStorage.setItem("from", from);
    }
    if (token) {
      storage.setItem("token", token);
      if (!is_new) {
        sessionStorage.setItem("isAutoLogin", true);
      }
    }
    if (game_id || gid) {
      sessionStorage.setItem("game_id", Number(game_id || gid));
    }
    if (is_new) {
      sessionStorage.setItem("is_new", is_new);
    }
    await this.getKfInit();
    await this.getIndexData();
    // 获取游戏信息后，修改title
    if (
      this.indexData &&
      this.indexData.chat_game &&
      this.indexData.chat_game.name
    ) {
      document.title = this.indexData.chat_game.name;
    }
    await this.getInitInfos();
    this.isInit = true;

    this.hideLoading();
  },
  mounted() {
    this.showLoading();
    if (this.isWeiXin() && !sessionStorage.getItem("is_new")) {
      // 微信自动登录跳转
      if (this.vuexInitData.is_zy) {
        const origin = location.origin;
        const search = location.search;
        const path = this.$route.path || "/user-center";
        const gameId = storage.getGameId();
        const query = search
          ? `${search}&game_id=${gameId}`
          : `?game_id=${gameId}`;
        const jump_url = encodeURI(origin + path + query);
        window.location =
          process.env.VUE_APP_API +
          "/v1/public/login/autologin?game_id=" +
          gameId +
          "&jump_url=" +
          jump_url;
      }
    }
    this.hideLoading();
  },
  methods: {
    ...mapActions(["getKfInit", "getUserInfo", "getIndexData"]),
    async getRoleList() {
      await this.$store.dispatch("getRoleList");
    },
    async getInitInfos() {
      const token = storage.getItem("token");
      if (token) {
        await this.getRoleList();
        await this.getUserInfo();
      }

      this.$store.dispatch("getGlobalNotice");
    },
    isWeiXin() {
      var ua = window.navigator.userAgent.toLowerCase();

      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
<style lang="less" scoped>
#layout {
  width: 100%;
  height: 100%;
}
</style>
